var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader',{attrs:{"loaded":_vm.promotions,"marginTop":25}}),(_vm.$vuetify.breakpoint.xsOnly)?_c('XsPromotions'):_c('Promotions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }